import React from 'react'
import PropTypes from 'prop-types'

import './RecommendationAdditionBox.css'

const RecommendationAdditionBox = ({handleClick}) => {
  return <div className='uk-height-small shot-grid-cell'>
    <div
      className={`add-shot uk-align-center`}
      onClick={handleClick}>
      <div className='content uk-inline clickable'>
        <i className='fas fa-plus fa-3x uk-position-center' />
      </div>
    </div>
  </div>
}

RecommendationAdditionBox.propTypes = {
  handleClick: PropTypes.func.isRequired
}
export default RecommendationAdditionBox
